import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getStoreLocalData, getUserData } from "../../../utils/localStorage";
import {
  getCustomerPackageOffer,
  postCustomerPackageOfferSubscriptionRollback,
} from "../../../services/CustomerPackageOffer/CustomerPackageOffer";
import { formatDate } from "../../../constants/DateUtil/DateUtil";
import { ProgressSpinner } from "primereact/progressspinner";
import CustomerPackageStatusChange from "./CustomerPackageStatusChange";
import CustomerStorePackageOfferAddModal from "./CustomerStorePackageOfferAddModal";
import { Checkbox } from "primereact/checkbox";
import { setPackageSubscriptionOfferDefault } from "../../../services/PaymentOfferManagement/CheckPackageSubscriptionOffer";
import CustomerStorePackageOfferReSubscribeModal from "./CustomerStorePackageOfferReSubscribeModal";
import ButtonLink from "../../../ButtonLink";
import CustomerStorePackageOfferAddModalAdmin from "./CustomerStorePackageOfferAddModalAdmin";
import CustomerStorePackageOfferReSubscribeModalAdmin from "./CustomerStorePackageOfferReSubscribeModalAdmin";
import { getBrandStoreById } from "../../../services/StoreUsers/PostStoreUsers";
import { Dropdown } from "primereact/dropdown";
import { use } from "react";
import { MultiSelect } from "primereact/multiselect";
import ConfirmPackageStatusChange from "./ConfirmPackageStatusChange";

const CustomerPackageOffer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { storeLocalData } = getStoreLocalData();
  const countryCode = storeLocalData?.countryCode;

  const { storeCustomerId, customerData, storeIdValue } = location.state || {};

  const { storeData, brandProfileData, userProfileData, userProfileRole } =
    getUserData();

  const [adminStoreData, setAdminStoreData] = useState({});

  const fetchStoreUser = () => {
    getBrandStoreById(storeId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setAdminStoreData(Res);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    fetchStoreUser();
  }, []);

  const gstValue =
    userProfileRole === "BY_STORE" ? storeData.gst : adminStoreData.gst;
  const storeGstNumber =
    userProfileRole === "BY_STORE" ? storeData.gstNo : adminStoreData.gstNo;
  const storeGstType =
    userProfileRole === "BY_STORE" ? storeData.gstType : adminStoreData.gstType;

  const storeId = userProfileRole === "BY_STORE" ? storeData.id : storeIdValue;

  let enabledUPIAccount =
    userProfileRole === "BY_STORE"
      ? storeData.enabledUPIAccount
      : adminStoreData.enabledUPIAccount;
  let upiAccountId =
    userProfileRole === "BY_STORE"
      ? storeData.upiAccountId
      : adminStoreData.upiAccountId;
  let upiAccountLink =
    userProfileRole === "BY_STORE"
      ? storeData.upiAccountLink
      : adminStoreData.upiAccountLink;
  let upiAccountName =
    userProfileRole === "BY_STORE"
      ? storeData.upiAccountName
      : adminStoreData.upiAccountName;
  let enabledQRDeviceModal =
    userProfileRole === "BY_STORE"
      ? storeData.enabledQRDeviceModal
      : adminStoreData.enabledQRDeviceModal;

  const [statusValue, setStatusValue] = useState("");

  const statusValueData = [
    "PROSPECTIVE",
    "ACTIVE",
    "INACTIVE",
    "RUNNING",
    "CONSUMED",
  ];

  const handleStatusValueChange = (selectedItem) => {
    setStatusValue(selectedItem);
  };

  let brandId = brandProfileData.id;
  let storeUserId = userProfileData.id;
  const [loading, setLoading] = useState(true);
  const [
    customerStorePackageOfferModalVisible,
    setCustomerStorePackageOfferModalVisible,
  ] = useState("");

  const [
    customerStorePackageOfferReSubscribeModalVisible,
    setCustomerStorePackageOfferReSubscribeModalVisible,
  ] = useState("");

  const [
    customerStorePackageOfferReSubscribeModalData,
    setCustomerStorePackageOfferReSubscribeModalData,
  ] = useState({});

  const [
    confirmPackageStatusChangeVisible,
    setConfirmPackageStatusChangeVisible,
  ] = useState(false);

  const [confirmPackageStatusChangeItem, setConfirmPackageStatusChangeItem] =
    useState({});

  const [customerPackageOfferData, setCustomerPackageOfferData] = useState([]);
  const fetchCustomerPackageOfferList = (data) => {
    getCustomerPackageOffer(brandId, data)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setCustomerPackageOfferData(Res);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    const requestData = {
      statusIn: statusValue ? statusValue : ["ACTIVE", "RUNNING"],
      brandId: brandId,
      storeCustomerId: [storeCustomerId],
    };

    fetchCustomerPackageOfferList(requestData);
  }, [statusValue]);

  const receiveDataFromOfferAddModal = ({ success }) => {
    if (success) {
      const requestData = {
        statusIn: statusValue ? statusValue : ["ACTIVE", "RUNNING"],
        brandId: brandId,
        storeCustomerId: [storeCustomerId],
      };

      fetchCustomerPackageOfferList(requestData);
    }
  };

  const shareMessage = (item) => {
    const mobile = customerData?.brandCustomer?.mobile;

    // Remove any non-numeric characters and check if the number starts with a '+'
    let formattedMobile = mobile.replace(/[^\d+]/g, ""); // Remove non-numeric and non-plus characters

    if (!formattedMobile.startsWith("+")) {
      formattedMobile = `${countryCode}${formattedMobile}`; // Add country code only if not already present
    }

    const body = `${item.notification}`;

    if (!formattedMobile) {
      return alert("Mobile number is invalid");
    }

    let url = `https://api.whatsapp.com/send?text=${encodeURIComponent(
      body,
    )}&phone=${formattedMobile}`;

    window.open(url, "_blank");
  };

  const handleStatusToggle = (item) => {
    // setSelectedStatus(status);
    if (item.id !== null) {
      setPackageSubscriptionOfferDefault(brandId, storeId, item.id).then(
        (response) => {
          if (!response.data.error) {
            const Res = response.data;
            if (Res.status) {
              const requestData = {
                statusIn: ["ACTIVE"],
                brandId: brandId,
                storeCustomerId: [storeCustomerId],
              };

              fetchCustomerPackageOfferList(requestData);
            }
          }
        },
      );
    }
  };

  const handleStatusChange = (item) => {
    setConfirmPackageStatusChangeVisible(true);
    setConfirmPackageStatusChangeItem(item);
  };

  const handleSubscriptionRollBack = (item) => {
    const data = {
      receivedBy: storeUserId,
      paidBy: storeCustomerId,
      amount: 0,
      paymentMode: "",
    };
    const updatedData = {
      status: "ACTIVE",
      brandPackageOffer: {
        id: item?.brandPackageOffer?.id,
      },
      storeCustomerId: storeCustomerId,
      paymentDTO: data,
    };

    const subscriberId = item?.id;

    postCustomerPackageOfferSubscriptionRollback(
      brandId,
      storeId,
      subscriberId,
      updatedData,
    )
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          if (Res) {
            const message = Res.message;
            const status = Res.status;

            const requestData = {
              statusIn: statusValue ? statusValue : ["ACTIVE", "RUNNING"],
              brandId: brandId,
              storeCustomerId: [storeCustomerId],
            };

            fetchCustomerPackageOfferList(requestData);
          }
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const renderCardItem = () => {
    return customerPackageOfferData.map((item) => (
      <div
        className=" shadow-5 surface-0 flex-1 mb-4 mx-4 border-round-lg"
        style={{
          backgroundImage: item.default
            ? "radial-gradient(circle at left top, #FAF6CF, #FAF6CF)"
            : "radial-gradient(circle at left top, #fff, #fff)",
        }}
      >
        <div className="px-4">
          <div className="grid mt-1">
            <div className="col">
              <p className="text-md font-normal capitalize">Offer Name :</p>
              <p className="text-lg font-semibold capitalize">
                {item.brandPackageOffer.name.replace(/_/g, " ")}
              </p>
            </div>

            <div className="col">
              <p className="text-md font-normal capitalize">Category :</p>
              <p className="text-lg font-semibold capitalize">
                {item.brandPackageOffer.offerCategory.name.replace(/_/g, " ")}
              </p>
            </div>

            <div className="col">
              <div className="flex">
                <div>
                  <p className="text-md font-normal capitalize">
                    Days To Consume :
                  </p>

                  <p className="text-lg font-semibold capitalize">
                    {item.brandPackageOffer.validity}
                  </p>
                </div>
                <i
                  onClick={() => shareMessage(item)}
                  className="pi pi-whatsapp mx-4"
                  style={{
                    fontSize: "25px",
                    cursor: "pointer",
                    color: "green",
                  }}
                ></i>
                <div
                  className="cursor-pointer"
                  onClick={() => {
                    navigate("/PackagePaymentReceipt", {
                      state: {
                        customerData: customerData,
                        storeCustomerId: storeCustomerId,
                        paymentDetails: item,
                        storeId: storeId,
                      },
                    });
                  }}
                >
                  <img
                    src={"Laundy_App_Icons_Gifs/Other_Icons/View_Invoice.png"}
                    style={{
                      width: 30,
                      height: 30,
                    }}
                  />
                </div>
                {userProfileRole === "BY_ADMIN" && item.leftDiscount > 0 && (
                  <div
                    onClick={() =>
                      navigate("/CustomerSubscriptionTransferToWallet", {
                        state: {
                          brandId: brandId,
                          storeId: storeId,
                          storeCustomerId: storeCustomerId,
                          item: item,
                          customerData: customerData,
                        },
                      })
                    }
                    style={{ marginLeft: 10 }}
                  >
                    <img
                      src={"images/transfer.png"}
                      style={{
                        width: 30,
                        height: 30,
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="px-4">
          <div className="grid ">
            <div className="col">
              <p className="text-md font-normal capitalize">Discount :</p>
              <p className="text-lg font-semibold capitalize">
                {item.brandPackageOffer.value} %
              </p>
            </div>

            <div className="col">
              <p className="text-md font-normal capitalize">Service Value :</p>
              <p className="text-lg font-semibold capitalize">
                {item.brandPackageOffer.serviceValue}
              </p>
            </div>

            <div className="col">
              <p className="text-md font-normal capitalize">Package Value :</p>
              <p className="text-lg font-semibold capitalize">
                {item.brandPackageOffer.packageValue}
              </p>
            </div>
          </div>
        </div>
        <div className="px-4">
          <div className="grid">
            <div className="col">
              <p className="text-md font-normal capitalize">
                Available Discount :
              </p>
              <p className="text-lg font-semibold capitalize">
                {item.leftDiscount > 0 ? item.leftDiscount : 0}
              </p>
            </div>

            <div className="col">
              <div className="flex">
                <p className="text-md font-normal capitalize">
                  Consumed Discount :
                </p>
                {item.totalDiscount > 0 && (
                  <div
                    className="cursor-pointer"
                    onClick={() =>
                      navigate("/CustomerPackageOfferLog", {
                        state: {
                          brandId: brandId,
                          storeId: storeId,
                          storeCustomerId: storeCustomerId,
                          item: item,
                          customerData: customerData,
                        },
                      })
                    }
                    style={{ marginLeft: 10 }}
                  >
                    <i
                      className="pi pi-eye"
                      style={{
                        fontSize: "20px",
                        cursor: "pointer",
                        color: "#2B70D7",
                      }}
                    ></i>
                  </div>
                )}
                <div
                  className="cursor-pointer ml-2"
                  onClick={() => {
                    navigate("/CustomerPackageOfferLogNew", {
                      state: {
                        brandId: brandId,
                        storeId: storeId,
                        storeCustomerId: storeCustomerId,
                        item: item,
                        customerData: customerData,
                      },
                    });
                  }}
                >
                  <img
                    src={"Laundy_App_Icons_Gifs/Other_Icons/View_Invoice.png"}
                    style={{
                      width: 20,
                      height: 20,
                    }}
                  />
                </div>
              </div>
              <p className="text-lg font-semibold capitalize">
                {Number(item.totalDiscount?.toFixed(2))}
              </p>
            </div>

            <div className="col">
              {/*item.status !== "RUNNING" && 
                userProfileRole === "BY_STORE" && (
                <div className="flex flex-1 flex-row">
                  <div style={{ flex: 1 }}>
                    <p className="text-md font-normal capitalize">Status :</p>
                    <p className="text-lg font-semibold capitalize">
                        {item.status === "ACTIVE" ? "ACTIVE" : item.status}{" "}
                    </p>
                  </div>
                  <div style={{ flex: 1, marginRight: 10 }}>
                    <CustomerPackageStatusChange
                      status={item.status}
                      sendDataToCustomerPackage={receiveDataFromOfferAddModal}
                      editData={item}
                      brandId={brandId}
                      storeId={storeId}
                      storeCustomerId={storeCustomerId}
                    />
                  </div>
                </div>
              )*/}

              <div className="flex flex-1 flex-row">
                <div style={{ flex: 1 }}>
                  <p className="text-md font-normal capitalize">Status :</p>
                  <p className="text-lg font-semibold capitalize">
                    {item.status === "ACTIVE" ? "ACTIVE" : item.status}{" "}
                  </p>
                </div>
                {userProfileRole !== "BY_STORE" && ["PROSPECTIVE", "ACTIVE"].includes(item.status) && (
                  <div style={{ flex: 1, marginRight: 10,  }}>
                    <div
                      style={{ backgroundColor: "#1785ec" }}
                      className="px-2 py-1 border-round-md flex justify-content-center cursor-pointer"
                      onClick={() => handleStatusChange(item)}
                    >
                      <p className="text-white text-lg font-bold uppercase">
                        {item?.status === "ACTIVE"
                          ? " Set To INACTIVE"
                          : item?.status === "PROSPECTIVE"
                            ? " Set To ACTIVE"
                            : ""}
                      </p>
                    </div>
                  </div>
                )}
                {/* {userProfileRole !== "BY_STORE" && item.status !== "RUNNING" && (
                  <div style={{ flex: 1, marginRight: 10 }}>
                    <CustomerPackageStatusChange
                      status={item.status}
                      sendDataToCustomerPackage={receiveDataFromOfferAddModal}
                      editData={item}
                      brandId={brandId}
                      storeId={storeId}
                      storeCustomerId={storeCustomerId}
                    />
                  </div>
                )} */}
              </div>
            </div>
          </div>
        </div>
        <div className="px-4">
          <div className="grid">
            <div className="col">
              <p className="text-md font-normal capitalize">
                Subscription Date :
              </p>
              <p className="text-lg font-semibold capitalize">
                {formatDate(item.createdDate)}
              </p>
            </div>

            <div className="col">
              <p className="text-md font-normal capitalize">Valid From :</p>
              <p className="text-lg font-semibold capitalize">
                {formatDate(item.validFrom)}
              </p>
            </div>

            <div className="col">
              <p className="text-md font-normal capitalize">Valid To :</p>
              <p className="text-lg font-semibold capitalize">
                {formatDate(item.validTo)}
              </p>
            </div>
          </div>
        </div>
        <div className="px-4">
          <div className="grid">
            <div className="col">
              <div className="flex">
                <p className="text-md font-normal capitalize">
                  Subscription Count :
                </p>
                {item.subsCount > 0 && (
                  <div
                    className="cursor-pointer"
                    onClick={() =>
                      navigate("/CustomerPackageOfferSubscriptionLog", {
                        state: {
                          brandId: brandId,
                          storeId: storeId,
                          storeCustomerId: storeCustomerId,
                          item: item,
                          customerData: customerData,
                        },
                      })
                    }
                    style={{ marginLeft: 10 }}
                  >
                    <i
                      className="pi pi-eye"
                      style={{
                        fontSize: "20px",
                        cursor: "pointer",
                        color: "#2B70D7",
                      }}
                    ></i>
                  </div>
                )}
              </div>
              <p className="text-lg font-semibold capitalize">
                {item.subsCount}
              </p>
            </div>
            <div className="col">
              {["RUNNING", "ACTIVE"].includes(item.status) && (
                <div
                  style={{
                    marginTop: 5,
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-start",
                    alignItems: "center",
                  }}
                >
                  <p className="text-lg font-semibold capitalize mr-4">
                    Default :
                  </p>
                  <p className="text-lg font-semibold capitalize">
                    <Checkbox
                      checked={item.default}
                      size={16} // Increased size
                      color={item.default ? "#00A3FF" : "#C1C9D3"}
                      onClick={() => handleStatusToggle(item)}
                    />
                  </p>
                </div>
              )}
            </div>

            <div className="col">
              <div className="flex flex-1 flex-row">
                {["RUNNING", "CONSUME"].includes(item.status) && (
                  <div className="flex flex-1 flex-row">
                    <p className="text-lg font-semibold capitalize flex justify-content-center align-items-center mr-4">
                      Re-Subscribe :
                    </p>
                    <div
                      onClick={() => {
                        setCustomerStorePackageOfferReSubscribeModalVisible(
                          true,
                        );
                        setCustomerStorePackageOfferReSubscribeModalData(item);
                      }}
                      style={{ marginRight: 10, marginTop: 5 }}
                    >
                      <i
                        className="pi pi-sync"
                        style={{
                          fontSize: "27px",
                          cursor: "pointer",
                          color: "blue",
                        }}
                      ></i>
                    </div>
                  </div>
                )}
                {userProfileRole === "BY_ADMIN" && (
                  <div className="flex flex-1 flex-row">
                    <p className="text-lg font-semibold capitalize flex justify-content-center align-items-center mr-4">
                      Sub-RollBack:
                    </p>
                    <div
                      onClick={() => {
                        handleSubscriptionRollBack(item);
                      }}
                      style={{ marginRight: 10, marginTop: 5 }}
                    >
                      <i
                        className="pi pi-sync"
                        style={{
                          fontSize: "27px",
                          cursor: "pointer",
                          color: "blue",
                        }}
                      ></i>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    ));
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() =>
                    navigate("/Customer-Subscription", {
                      state: {
                        customerData: customerData,
                        storeCustomerId: storeCustomerId,
                        storeIdValue: storeId,
                      },
                    })
                  }
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold uppercase">
                Customer Package Offer
              </p>
            </div>
          </div>

          <div className="mx-3 w-2 QrCodeTag-dropdown">
            {/*<Dropdown
              value={statusValue}
              options={statusValueData}
              onChange={(e) => handleStatusValueChange(e.value)}
              placeholder="Select a Status"
              className="w-full  border-round-lg m-1"
              style={{ height: 30 }}
              optionLabel="name"
            />*/}

            <MultiSelect
              display="chip"
              value={statusValue}
              options={statusValueData}
              className="w-full  border-round-lg m-1 customerPackageOfferMultiSelect"
              style={{ height: 30 }}
              onChange={(e) => {
                handleStatusValueChange(e.target.value);
              }}
              placeholder="Select a Status"
            />
          </div>

          <div className="flex justify-content-center align-items-center cursor-pointer mx-4">
            <div
              onClick={() => {
                setCustomerStorePackageOfferModalVisible(true);
              }}
            >
              <i
                className="pi pi-plus-circle"
                style={{
                  fontSize: "27px",
                  cursor: "pointer",
                  color: "#fff",
                }}
              ></i>
            </div>
          </div>
        </div>
      </div>

      <div
        style={{
          marginTop: 10,
          marginBottom: 60,
        }}
      >
        {loading ? (
          <div className="flex flex-column justify-content-center align-items-center ">
            <ProgressSpinner />

            <p className="text-2xl">Package List is Loading...</p>
          </div>
        ) : customerPackageOfferData.length === 0 ? (
          <div>
            <p className="text-2xl font-semibold text-center">
              No Package Found
            </p>
          </div>
        ) : (
          renderCardItem()
        )}

        {customerStorePackageOfferModalVisible &&
          (userProfileRole === "BY_STORE" ? (
            <CustomerStorePackageOfferAddModal
              customerStorePackageOfferModalVisible={
                customerStorePackageOfferModalVisible
              }
              setCustomerStorePackageOfferModalVisible={
                setCustomerStorePackageOfferModalVisible
              }
              sendDataToCustomerPackageOffer={receiveDataFromOfferAddModal}
              brandId={brandId}
              storeCustomerId={storeCustomerId}
              storeId={storeId}
              storeUserId={storeUserId}
              gstValue={gstValue}
              storeGstNumber={storeGstNumber}
              storeGstType={storeGstType}
              enabledUPIAccount={enabledUPIAccount}
              upiAccountId={upiAccountId}
              upiAccountLink={upiAccountLink}
              upiAccountName={upiAccountName}
              enabledQRDeviceModal={enabledQRDeviceModal}
            />
          ) : (
            <CustomerStorePackageOfferAddModalAdmin
              customerStorePackageOfferModalVisible={
                customerStorePackageOfferModalVisible
              }
              setCustomerStorePackageOfferModalVisible={
                setCustomerStorePackageOfferModalVisible
              }
              sendDataToCustomerPackageOffer={receiveDataFromOfferAddModal}
              brandId={brandId}
              storeCustomerId={storeCustomerId}
              storeId={storeId}
              storeUserId={storeUserId}
              gstValue={gstValue}
              storeGstNumber={storeGstNumber}
              storeGstType={storeGstType}
              enabledUPIAccount={enabledUPIAccount}
              upiAccountId={upiAccountId}
              upiAccountLink={upiAccountLink}
              upiAccountName={upiAccountName}
              enabledQRDeviceModal={enabledQRDeviceModal}
            />
          ))}

        {customerStorePackageOfferReSubscribeModalVisible &&
          (userProfileRole === "BY_STORE" ? (
            <CustomerStorePackageOfferReSubscribeModal
              customerStorePackageOfferReSubscribeModalVisible={
                customerStorePackageOfferReSubscribeModalVisible
              }
              setCustomerStorePackageOfferReSubscribeModalVisible={
                setCustomerStorePackageOfferReSubscribeModalVisible
              }
              sendDataToCustomerPackageOffer={receiveDataFromOfferAddModal}
              ReSubscribeModalData={
                customerStorePackageOfferReSubscribeModalData
              }
              brandId={brandId}
              storeCustomerId={storeCustomerId}
              storeId={storeId}
              storeUserId={storeUserId}
              gstValue={gstValue}
              storeGstNumber={storeGstNumber}
              storeGstType={storeGstType}
              enabledUPIAccount={enabledUPIAccount}
              upiAccountId={upiAccountId}
              upiAccountLink={upiAccountLink}
              upiAccountName={upiAccountName}
              enabledQRDeviceModal={enabledQRDeviceModal}
            />
          ) : (
            <CustomerStorePackageOfferReSubscribeModalAdmin
              customerStorePackageOfferReSubscribeModalVisible={
                customerStorePackageOfferReSubscribeModalVisible
              }
              setCustomerStorePackageOfferReSubscribeModalVisible={
                setCustomerStorePackageOfferReSubscribeModalVisible
              }
              sendDataToCustomerPackageOffer={receiveDataFromOfferAddModal}
              ReSubscribeModalData={
                customerStorePackageOfferReSubscribeModalData
              }
              brandId={brandId}
              storeCustomerId={storeCustomerId}
              storeId={storeId}
              storeUserId={storeUserId}
              gstValue={gstValue}
              storeGstNumber={storeGstNumber}
              storeGstType={storeGstType}
              enabledUPIAccount={enabledUPIAccount}
              upiAccountId={upiAccountId}
              upiAccountLink={upiAccountLink}
              upiAccountName={upiAccountName}
              enabledQRDeviceModal={enabledQRDeviceModal}
            />
          ))}

        <ConfirmPackageStatusChange
          confirmPackageStatusChangeVisible={confirmPackageStatusChangeVisible}
          setConfirmPackageStatusChangeVisible={
            setConfirmPackageStatusChangeVisible
          }
          sendDataToCustomerPackage={receiveDataFromOfferAddModal}
          confirmPackageStatusChangeItem={confirmPackageStatusChangeItem}
          brandId={brandId}
          storeId={storeId}
          storeCustomerId={storeCustomerId}
        />
      </div>
      <ButtonLink />
    </div>
  );
};

export default CustomerPackageOffer;
